import { z } from 'zod';
export const superset = z.object({
    token: z.string(),
    domain: z.string(),
    dashboardId: z.string(),
});
//# sourceMappingURL=superset.js.map